import { styled } from '@mui/material/styles';
import { Avatar, Typography, Button } from '@mui/material';

export const CupomWrapper = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    justifyContent: 'center',
    backgroundColor: '#eaf2fd',
    borderRadius: 20,
    // overflow: 'hidden',
    maxWidth: 400,
    margin: '0 auto 20px auto',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        maxWidth: '60vw', 
    },
}));

export const CashbackText = styled('span')(({ theme }) => ({
    fontWeight: 'bold',
    color: '#3599DB',
    fontSize: 14,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
}));
export const StoreAvatar = styled(Avatar)`
    width: 120px;
    height: 60px;
    border-radius: 10px;

    @media (min-width: 600px) {
        width: 150px;
        height: 112px;
    }
`;

export const CupomBox = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    margin: 'auto',
}));

export const CouponCodeBox = styled('input')(({ theme }) => ({
    textAlign: 'center',
    padding: '12px 20px',
    fontWeight: 600,
    color: '#3599db',
    // maxWidth: '100px',
    width: '50%',
    // border: '1px solid red',
    fontSize: '16px',
    backgroundColor: '#eaf2fd',
    minWidth: 100,
    margin: 'auto',
    borderTopLeftRadius: 20, 
    borderBottomLeftRadius: 20 ,
    [theme.breakpoints.down('sm')]: {
        fontSize: '14px',
    },
}));

export const TitleTypography = styled(Typography)(({ theme }) => ({
    color: '#3599db',
    fontWeight: 'bold',
    fontSize: '22px',
    marginTop: theme.spacing(1),
    marginBottom: 0,
    [theme.breakpoints.down('sm')]: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(2),
    },
}));

export const LinkTypography = styled(Typography)(({ theme }) => ({
    color: '#3599DB',
    cursor: 'pointer',
    textDecoration: 'underline',
    fontSize: '0.8rem',
    '&:hover': { opacity: 0.8 },
}));

export const CouponButton = styled(Button)(({ theme }) => ({
    borderRadius: 0,
    height: '100%',
    fontSize: '14px',
    textTransform: 'none',
    padding: '12px 24px',
    whiteSpace: 'nowrap',
    borderTopRightRadius: 20,
    borderBottomRightRadius: 20,
    borderTopLeftRadius: 20,
    borderBottomLeftRadius: 20,
    backgroundColor: '#3599db',
    color: '#fff',
    fontWeight: 600,
    transition: 'all 0.3s ease',

    '&:hover': {
        backgroundColor: '#2b7fbf',
    },

    '&:disabled': {
        backgroundColor: '#ccc',
        color: '#666',
    },

    [theme.breakpoints.up('md')]: {
        borderRadius: 20,
    },
}));